var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListPrice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2943_6152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 4.25V6.125H4.21875V4.25H9.46875ZM13.2188 8H4.21875V9.875H13.2188V8ZM4.21875 17.375H7.78125V15.5H4.21875V17.375ZM16.9688 4.25V11.7668C16.2224 12.0938 15.5774 12.6103 15.0938 13.2545V6.125H11.3438V2.375H2.34375V19.25H14.1562V19.8125C14.1562 20.268 14.2223 20.7083 14.3441 21.125H0.46875V0.5H13.2188C15.2865 0.5 16.9688 2.18225 16.9688 4.25ZM15.0938 4.25C15.0938 3.21613 14.2526 2.375 13.2188 2.375V4.25H15.0938ZM13.2188 17.375V15.5H9.65625V17.375H13.2188ZM13.2188 11.75H4.21875V13.625H13.2188V11.75ZM20.7188 22.625C22.2696 22.625 23.5312 21.3633 23.5312 19.8125C23.5312 18.2617 22.2696 17 20.7188 17H18.8438C18.3268 17 17.9062 16.5794 17.9062 16.0625C17.9062 15.5456 18.3268 15.125 18.8438 15.125H20.7188C21.2357 15.125 21.6562 15.5456 21.6562 16.0625H23.5312C23.5312 14.5117 22.2696 13.25 20.7188 13.25V11.375H18.8438V13.25C17.2929 13.25 16.0312 14.5117 16.0312 16.0625C16.0312 17.6133 17.2929 18.875 18.8438 18.875H20.7188C21.2357 18.875 21.6562 19.2956 21.6562 19.8125C21.6562 20.3294 21.2357 20.75 20.7188 20.75H18.8438C18.3268 20.75 17.9062 20.3294 17.9062 19.8125H16.0312C16.0312 21.3633 17.2929 22.625 18.8438 22.625V24.5H20.7188V22.625Z",
    fill: "#4D2481"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2943_6152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPrice);
export default __webpack_public_path__ + "static/media/list-price.bba21e5872b9ded3ff6279184a94aa66.svg";
export { ForwardRef as ReactComponent };